import img07 from "../../images/chapters/03/07.jpg";
import img08 from "../../images/chapters/03/08.jpg";
import img09 from "../../images/chapters/03/09.jpg";
import img10 from "../../images/chapters/03/10.jpg";
import img11 from "../../images/chapters/03/11.jpg";
import img12 from "../../images/chapters/03/12.jpg";
import img13 from "../../images/chapters/03/13.jpg";

import gif01 from "../../images/chapters/03/gifs/01.gif";
import gif02 from "../../images/chapters/03/gifs/02.gif";
import gif03 from "../../images/chapters/03/gifs/03.gif";
import gif04 from "../../images/chapters/03/gifs/04.gif";
import gif05 from "../../images/chapters/03/gifs/05.gif";

export const captions = [
  "Apollo 11 Lunar Module Pilot Buzz Aldrin during suiting.",
  "Michael Collins inside an Apollo Command Module (CM) mock-up in building 5 practicing procedures with the Apollo docking mechanism in preparation for the scheduled Apollo 11 lunar landing mission. Collins is at the Commando Module’s docking tunnel which provides a passageway to and from the Lunar Module (LM) following docking, and after removal of the tunnel hatches, docking probe and drogue.",
  "Buzz (left) and Neil during training.",
  "Neil Armstrong rests during extravehicular activity training.",
  "Buzz Aldrin uses a triggerless Hasselblad camera during EVA training.",
  "Buzz (right) uses the tongs to collect a small rock while Neil holds open an individual sample bag.",
  "Buzz (right) collects a soil sample with the large box scoop.",
];

export const list = [
  { img: img07, caption: captions[2] },
  { img: img08, caption: captions[3] },
  { img: img09, caption: captions[4] },
  { img: img10 },
  { img: img11 },
  { img: img12 },
  { img: img13 },
];

export const gifs = [gif01, gif02, gif03, gif04, gif05];
